// @ts-nocheck
import deepmerge from 'deepmerge'

import {
  type RawResultItem,
  type ResultsState,
  type SearchHit,
} from 'types/search'

export const hasResults = ({ rawResults }: ResultsState): boolean =>
  Boolean(rawResults?.[0]?.nbHits)

export const getProperty = <T = unknown>(
  resultsState: ResultsState,
  property: keyof RawResultItem,
  defaultPropertyValue: T
): T => (resultsState?.rawResults?.[0]?.[property] || defaultPropertyValue) as T

export const setProperty = (
  resultsState: ResultsState,
  { key, value }: { key: keyof RawResultItem; value: unknown }
) => {
  if (!hasResults(resultsState)) {
    throw new Error('Algolia response has no results data')
  }

  const newResultsState = deepmerge({}, resultsState)
  const record: GenericRecord = newResultsState.rawResults[0]
  record[key] = value

  return newResultsState
}

export const getHitsAmount = (resultsState: ResultsState): number =>
  getProperty<number>(resultsState, 'nbHits', 0)

export const getHits = (resultsState: ResultsState): SearchHit[] =>
  getProperty<SearchHit[]>(resultsState, 'hits', [])
